export const palettes = {
  midnight: {
    backgroundPrimary:    '#0b1f3b',
    backgroundSecondary:  '#122844',
    backgroundTertiary:   '#1c3552',
    contentPrimary:       '#e6f7ff',
    contentSecondary:     '#add8e6',
    contentTertiary:      '#99aacc',
    borderOpaque:         '#00d5fa',
    tableHeader:          '#1c3552',
    buttonPrimaryFill:    '#00d5fa',
    buttonPrimaryText:    '#0b1f3b',
    buttonPrimaryFillHover: '#00b0d0',
    buttonPrimaryTextHover: '#0b1f3b',
    buttonPrimaryFillActive: '#008ca8',
    buttonPrimaryTextActive: '#0b1f3b',
    buttonSecondaryFill: '#1c3552',
    buttonSecondaryText: '#e6f7ff',
    buttonSecondaryFillHover: '#122844',
    buttonSecondaryTextHover: '#e6f7ff',
    buttonSecondaryFillActive: '#0b1f3b',
    buttonSecondaryTextActive: '#e6f7ff',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#e6f7ff',
    buttonMinimalFillHover: 'rgba(0, 213, 250, 0.1)',
    buttonMinimalTextHover: '#e6f7ff',
    buttonMinimalFillActive: 'rgba(0, 213, 250, 0.2)',
    buttonMinimalTextActive: '#e6f7ff',
    inputFill: '#122844',
    inputBorder: '#00d5fa',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#1c3552',
    inputBorderActive: '#00d5fa',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#00d5fa',
    borderAccent: '#00d5fa',
    highlightBackground: '#ADD8E6',
  },
  forestNight: {
    backgroundPrimary:    '#0A1F08',
    backgroundSecondary:  '#1A3A1A',
    backgroundTertiary:   '#2F522F',
    contentPrimary:       '#E8F5E9',
    contentSecondary:     '#A5D6A7',
    contentTertiary:      '#88B888',
    borderOpaque:         '#66BB6A',
    tableHeader:          '#2F522F',
    buttonPrimaryFill:    '#66BB6A',
    buttonPrimaryText:    '#0A1F08',
    buttonPrimaryFillHover: '#5CB85C',
    buttonPrimaryTextHover: '#0A1F08',
    buttonPrimaryFillActive: '#4CAF50',
    buttonPrimaryTextActive: '#0A1F08',
    buttonSecondaryFill: '#2F522F',
    buttonSecondaryText: '#E8F5E9',
    buttonSecondaryFillHover: '#1A3A1A',
    buttonSecondaryTextHover: '#E8F5E9',
    buttonSecondaryFillActive: '#0A1F08',
    buttonSecondaryTextActive: '#E8F5E9',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#E8F5E9',
    buttonMinimalFillHover: 'rgba(102, 187, 106, 0.1)',
    buttonMinimalTextHover: '#E8F5E9',
    buttonMinimalFillActive: 'rgba(102, 187, 106, 0.2)',
    buttonMinimalTextActive: '#E8F5E9',
    inputFill: '#1A3A1A',
    inputBorder: '#66BB6A',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#2F522F',
    inputBorderActive: '#66BB6A',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#66BB6A',
    borderAccent: '#66BB6A',
    highlightBackground: '#A5D6A7',
  },
  charcoalMono: {
    backgroundPrimary:    '#212121',
    backgroundSecondary:  '#333333',
    backgroundTertiary:   '#424242',
    contentPrimary:       '#F5F5F5',
    contentSecondary:     '#BDBDBD',
    contentTertiary:      '#9E9E9E',
    borderOpaque:         '#9E9E9E',
    tableHeader:          '#424242',
    buttonPrimaryFill:    '#9E9E9E',
    buttonPrimaryText:    '#212121',
    buttonPrimaryFillHover: '#8D8D8D',
    buttonPrimaryTextHover: '#212121',
    buttonPrimaryFillActive: '#7C7C7C',
    buttonPrimaryTextActive: '#212121',
    buttonSecondaryFill: '#424242',
    buttonSecondaryText: '#F5F5F5',
    buttonSecondaryFillHover: '#333333',
    buttonSecondaryTextHover: '#F5F5F5',
    buttonSecondaryFillActive: '#212121',
    buttonSecondaryTextActive: '#F5F5F5',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#F5F5F5',
    buttonMinimalFillHover: 'rgba(158, 158, 158, 0.1)',
    buttonMinimalTextHover: '#F5F5F5',
    buttonMinimalFillActive: 'rgba(158, 158, 158, 0.2)',
    buttonMinimalTextActive: '#F5F5F5',
    inputFill: '#333333',
    inputBorder: '#9E9E9E',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#424242',
    inputBorderActive: '#9E9E9E',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#9E9E9E',
    borderAccent: '#9E9E9E',
    highlightBackground: '#BDBDBD',
  },
  paperInk: {
    backgroundPrimary:    '#FFFFFF',
    backgroundSecondary:  '#F5F5F5',
    backgroundTertiary:   '#EEEEEE',
    contentPrimary:       '#263238',
    contentSecondary:     '#CFD8DC',
    contentTertiary:      '#B0BEC5',
    borderOpaque:         '#546E7A',
    tableHeader:          '#EEEEEE',
    buttonPrimaryFill:    '#546E7A',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#455A64',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#37474F',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#EEEEEE',
    buttonSecondaryText: '#263238',
    buttonSecondaryFillHover: '#F5F5F5',
    buttonSecondaryTextHover: '#263238',
    buttonSecondaryFillActive: '#FFFFFF',
    buttonSecondaryTextActive: '#263238',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#263238',
    buttonMinimalFillHover: 'rgba(84, 110, 122, 0.1)',
    buttonMinimalTextHover: '#263238',
    buttonMinimalFillActive: 'rgba(84, 110, 122, 0.2)',
    buttonMinimalTextActive: '#263238',
    inputFill: '#F5F5F5',
    inputBorder: '#546E7A',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#EEEEEE',
    inputBorderActive: '#546E7A',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#546E7A',
    borderAccent: '#546E7A',
    highlightBackground: '#263238',
  },
  vintageSepia: {
    backgroundPrimary:    '#FAF0E6',
    backgroundSecondary:  '#F5EFE0',
    backgroundTertiary:   '#EAE0C8',
    contentPrimary:       '#5D4037',
    contentSecondary:     '#D7CCC8',
    contentTertiary:      '#C0A090',
    borderOpaque:         '#A1887F',
    tableHeader:          '#EAE0C8',
    buttonPrimaryFill:    '#A1887F',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#8D6E63',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#795548',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#EAE0C8',
    buttonSecondaryText: '#5D4037',
    buttonSecondaryFillHover: '#F5EFE0',
    buttonSecondaryTextHover: '#5D4037',
    buttonSecondaryFillActive: '#FAF0E6',
    buttonSecondaryTextActive: '#5D4037',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#5D4037',
    buttonMinimalFillHover: 'rgba(161, 136, 127, 0.1)',
    buttonMinimalTextHover: '#5D4037',
    buttonMinimalFillActive: 'rgba(161, 136, 127, 0.2)',
    buttonMinimalTextActive: '#5D4037',
    inputFill: '#F5EFE0',
    inputBorder: '#A1887F',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#EAE0C8',
    inputBorderActive: '#A1887F',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#A1887F',
    borderAccent: '#A1887F',
    highlightBackground: '#5D4037',
  },
  coolSlate: {
    backgroundPrimary:    '#ECEFF1',
    backgroundSecondary:  '#CFD8DC',
    backgroundTertiary:   '#B0BEC5',
    contentPrimary:       '#37474F',
    contentSecondary:     '#FFFFFF',
    contentTertiary:      '#90A4AE',
    borderOpaque:         '#78909C',
    tableHeader:          '#B0BEC5',
    buttonPrimaryFill:    '#78909C',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#607D8B',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#455A64',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#B0BEC5',
    buttonSecondaryText: '#37474F',
    buttonSecondaryFillHover: '#CFD8DC',
    buttonSecondaryTextHover: '#37474F',
    buttonSecondaryFillActive: '#ECEFF1',
    buttonSecondaryTextActive: '#37474F',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#37474F',
    buttonMinimalFillHover: 'rgba(120, 144, 156, 0.1)',
    buttonMinimalTextHover: '#37474F',
    buttonMinimalFillActive: 'rgba(120, 144, 156, 0.2)',
    buttonMinimalTextActive: '#37474F',
    inputFill: '#CFD8DC',
    inputBorder: '#78909C',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#B0BEC5',
    inputBorderActive: '#78909C',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#78909C',
    borderAccent: '#78909C',
    highlightBackground: '#37474F',
  },
  cyberNeon: {
    backgroundPrimary:    '#0A0A23',
    backgroundSecondary:  '#1C1C3D',
    backgroundTertiary:   '#2A2A5A',
    contentPrimary:       '#E0E0FF',
    contentSecondary:     '#F000B8',
    contentTertiary:      '#C0C0FF',
    borderOpaque:         '#F000B8',
    tableHeader:          '#2A2A5A',
    buttonPrimaryFill:    '#F000B8',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#D0009A',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#B0007C',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#2A2A5A',
    buttonSecondaryText: '#E0E0FF',
    buttonSecondaryFillHover: '#1C1C3D',
    buttonSecondaryTextHover: '#E0E0FF',
    buttonSecondaryFillActive: '#0A0A23',
    buttonSecondaryTextActive: '#E0E0FF',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#E0E0FF',
    buttonMinimalFillHover: 'rgba(240, 0, 184, 0.1)',
    buttonMinimalTextHover: '#E0E0FF',
    buttonMinimalFillActive: 'rgba(240, 0, 184, 0.2)',
    buttonMinimalTextActive: '#E0E0FF',
    inputFill: '#1C1C3D',
    inputBorder: '#F000B8',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#2A2A5A',
    inputBorderActive: '#F000B8',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#F000B8',
    borderAccent: '#F000B8',
    highlightBackground: '#E0E0FF',
  },
  goldenHour: {
    backgroundPrimary:    '#403A33',
    backgroundSecondary:  '#5A524A',
    backgroundTertiary:   '#7A6C5D',
    contentPrimary:       '#FFF8E1',
    contentSecondary:     '#FFF9C4',
    contentTertiary:      '#D0C0B0',
    borderOpaque:         '#FBC02D',
    tableHeader:          '#7A6C5D',
    buttonPrimaryFill:    '#FBC02D',
    buttonPrimaryText:    '#403A33',
    buttonPrimaryFillHover: '#F9A825',
    buttonPrimaryTextHover: '#403A33',
    buttonPrimaryFillActive: '#F57F17',
    buttonPrimaryTextActive: '#403A33',
    buttonSecondaryFill: '#7A6C5D',
    buttonSecondaryText: '#FFF8E1',
    buttonSecondaryFillHover: '#5A524A',
    buttonSecondaryTextHover: '#FFF8E1',
    buttonSecondaryFillActive: '#403A33',
    buttonSecondaryTextActive: '#FFF8E1',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#FFF8E1',
    buttonMinimalFillHover: 'rgba(251, 192, 45, 0.1)',
    buttonMinimalTextHover: '#FFF8E1',
    buttonMinimalFillActive: 'rgba(251, 192, 45, 0.2)',
    buttonMinimalTextActive: '#FFF8E1',
    inputFill: '#5A524A',
    inputBorder: '#FBC02D',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#7A6C5D',
    inputBorderActive: '#FBC02D',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#FBC02D',
    borderAccent: '#FBC02D',
    highlightBackground: '#FBC02D',
  },
  sunsetGlow: {
    backgroundPrimary:    '#4E342E',
    backgroundSecondary:  '#6D4C41',
    backgroundTertiary:   '#8D6E63',
    contentPrimary:       '#FFE0B2',
    contentSecondary:     '#FFAB91',
    contentTertiary:      '#D0A090',
    borderOpaque:         '#FF7043',
    tableHeader:          '#795548',
    buttonPrimaryFill:    '#FF7043',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#F4511E',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#E64A19',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#8D6E63',
    buttonSecondaryText: '#FFE0B2',
    buttonSecondaryFillHover: '#6D4C41',
    buttonSecondaryTextHover: '#FFE0B2',
    buttonSecondaryFillActive: '#4E342E',
    buttonSecondaryTextActive: '#FFE0B2',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#FFE0B2',
    buttonMinimalFillHover: 'rgba(255, 112, 67, 0.1)',
    buttonMinimalTextHover: '#FFE0B2',
    buttonMinimalFillActive: 'rgba(255, 112, 67, 0.2)',
    buttonMinimalTextActive: '#FFE0B2',
    inputFill: '#6D4C41',
    inputBorder: '#FF7043',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#8D6E63',
    inputBorderActive: '#FF7043',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#FF7043',
    borderAccent: '#FF7043',
    highlightBackground: '#FFA07A',
  },
  lemonZest: {
    backgroundPrimary:    '#FFFDE7',
    backgroundSecondary:  '#FFF9C4',
    backgroundTertiary:   '#FFF59D',
    contentPrimary:       '#424242',
    contentSecondary:     '#FFEE58',
    contentTertiary:      '#D0C0B0',
    borderOpaque:         '#FDD835',
    tableHeader:          '#FFF59D',
    buttonPrimaryFill:    '#FDD835',
    buttonPrimaryText:    '#424242',
    buttonPrimaryFillHover: '#FBC02D',
    buttonPrimaryTextHover: '#424242',
    buttonPrimaryFillActive: '#F9A825',
    buttonPrimaryTextActive: '#424242',
    buttonSecondaryFill: '#FFF59D',
    buttonSecondaryText: '#424242',
    buttonSecondaryFillHover: '#FFF9C4',
    buttonSecondaryTextHover: '#424242',
    buttonSecondaryFillActive: '#FFFDE7',
    buttonSecondaryTextActive: '#424242',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#424242',
    buttonMinimalFillHover: 'rgba(253, 216, 53, 0.1)',
    buttonMinimalTextHover: '#424242',
    buttonMinimalFillActive: 'rgba(253, 216, 53, 0.2)',
    buttonMinimalTextActive: '#424242',
    inputFill: '#FFF9C4',
    inputBorder: '#FDD835',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#FFF59D',
    inputBorderActive: '#FDD835',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#FDD835',
    borderAccent: '#FDD835',
    highlightBackground: '#404000',
  },
  rubyElegance: {
    backgroundPrimary:    '#2C0000',
    backgroundSecondary:  '#4A0000',
    backgroundTertiary:   '#6E0000',
    contentPrimary:       '#FFEBEE',
    contentSecondary:     '#FF8A80',
    contentTertiary:      '#C0A090',
    borderOpaque:         '#E53935', 
    tableHeader:          '#6E0000',
    buttonPrimaryFill:    '#E53935',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#D32F2F',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#C62828',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#6E0000',
    buttonSecondaryText: '#FFEBEE',
    buttonSecondaryFillHover: '#4A0000',
    buttonSecondaryTextHover: '#FFEBEE',
    buttonSecondaryFillActive: '#2C0000',
    buttonSecondaryTextActive: '#FFEBEE',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#FFEBEE',
    buttonMinimalFillHover: 'rgba(229, 57, 53, 0.1)',
    buttonMinimalTextHover: '#FFEBEE',
    buttonMinimalFillActive: 'rgba(229, 57, 53, 0.2)',
    buttonMinimalTextActive: '#FFEBEE',
    inputFill: '#4A0000',
    inputBorder: '#E53935',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#6E0000',
    inputBorderActive: '#E53935',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#E53935',
    borderAccent: '#E53935',
    highlightBackground: '#FF9999',
  },
  lavenderDream: {
    backgroundPrimary:    '#F3E5F5',
    backgroundSecondary:  '#E1BEE7',
    backgroundTertiary:   '#CE93D8',
    contentPrimary:       '#4A148C',
    contentSecondary:     '#BA68C8',
    contentTertiary:      '#90A4AE',
    borderOpaque:         '#AB47BC',
    tableHeader:          '#CE93D8',
    buttonPrimaryFill:    '#AB47BC',
    buttonPrimaryText:    '#FFFFFF',
    buttonPrimaryFillHover: '#9C27B0',
    buttonPrimaryTextHover: '#FFFFFF',
    buttonPrimaryFillActive: '#8E24AA',
    buttonPrimaryTextActive: '#FFFFFF',
    buttonSecondaryFill: '#CE93D8',
    buttonSecondaryText: '#4A148C',
    buttonSecondaryFillHover: '#E1BEE7',
    buttonSecondaryTextHover: '#4A148C',
    buttonSecondaryFillActive: '#F3E5F5',
    buttonSecondaryTextActive: '#4A148C',
    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#4A148C',
    buttonMinimalFillHover: 'rgba(171, 71, 188, 0.1)',
    buttonMinimalTextHover: '#4A148C',
    buttonMinimalFillActive: 'rgba(171, 71, 188, 0.2)',
    buttonMinimalTextActive: '#4A148C',
    inputFill: '#E1BEE7',
    inputBorder: '#AB47BC',
    inputBorderError: '#FF1A1A',
    inputFillError: '#FFCCCC',
    inputFillActive: '#CE93D8',
    inputBorderActive: '#AB47BC',
    inputBorderPositive: '#00CC00',
    inputFillPositive: '#CCFFCC',
    inputBorderWarning: '#FFA500',
    inputFillWarning: '#FFE0B2',
    negative: '#FF1A1A',
    positive: '#00CC00',
    warning: '#FFA500',
    accent: '#AB47BC',
    borderAccent: '#AB47BC',
    highlightBackground: '#7B1FA2',
  }
};